module.exports = __webpack_public_path__ + "img/coupon_btn.fdeefe8a.png";